import { useLocation, useSearchParams } from "react-router-dom"
import { useShallow } from "zustand/react/shallow"

import { useEffectOnce } from "@be-miniapp/ui/hooks/use-effect-once"

import {
  selectRideBookingActions,
  selectRidePickupDropoff,
} from "../stores/ride-data.selectors"
import type { RideDataStoreHook } from "./use-fare-page-model"

export function useFareValidation(deps: {
  useRideDataStore: RideDataStoreHook
  navigate: (to: string, options?: { replace?: boolean }) => void
}) {
  const { useRideDataStore, navigate } = deps
  const [searchParams] = useSearchParams()
  const { pickup, dropoff } = useRideDataStore(
    useShallow(selectRidePickupDropoff)
  )
  const { setVehicleType } = useRideDataStore(
    useShallow(selectRideBookingActions)
  )
  const initVehicleType = (
    useLocation().state as { vehicleType?: number } | null | undefined
  )?.vehicleType

  useEffectOnce(() => {
    const pickupLocation =
      searchParams.get("pickup") || searchParams.get("pickup_latlong")
    const dropoffLocation =
      searchParams.get("dropoff") || searchParams.get("dropoff_latlong")
    const vehicleType =
      (
        searchParams.get("selected_vehicles") ??
        searchParams.get("selected_vehicle")
      )?.split(",") || []

    const vehicleTypeCode = Number(vehicleType?.[0])
    if (vehicleTypeCode) {
      setVehicleType(vehicleTypeCode)
    }

    if (pickupLocation && dropoffLocation) {
      return
    }

    if (initVehicleType) {
      setVehicleType(initVehicleType)
      window.history.replaceState({}, "")
    }

    if (!pickup?.location?.latitude || !dropoff?.location?.latitude) {
      navigate("/ride/home", { replace: true })
    }
  })
}
